export let states = [
    { id: "select", text: "Select" },
    { id: "AL", text: "Alabama" },
    { id: "AK", text: "Alaska" },
    { id: "AZ", text: "Arizona" },
    { id: "AR", text: "Arkansas" },
    { id: "CA", text: "California" },
    { id: "CO", text: "Colorado" },
    { id: "CT", text: "Connecticut" },
    { id: "DE", text: "Delaware" },
    { id: "DC", text: "District Of Columbia" },
    { id: "FL", text: "Florida" },
    { id: "GA", text: "Georgia" },
    { id: "HI", text: "Hawaii" },
    { id: "ID", text: "Idaho" },
    { id: "IL", text: "Illinois" },
    { id: "IN", text: "Indiana" },
    { id: "IA", text: "Iowa" },
    { id: "KS", text: "Kansas" },
    { id: "KY", text: "Kentucky" },
    { id: "LA", text: "Louisiana" },
    { id: "ME", text: "Maine" },
    { id: "MD", text: "Maryland" },
    { id: "MA", text: "Massachusetts" },
    { id: "MI", text: "Michigan" },
    { id: "MN", text: "Minnesota" },
    { id: "MS", text: "Mississippi" },
    { id: "MO", text: "Missouri" },
    { id: "MT", text: "Montana" },
    { id: "NE", text: "Nebraska" },
    { id: "NV", text: "Nevada" },
    { id: "NH", text: "New Hampshire" },
    { id: "NJ", text: "New Jersey" },
    { id: "NM", text: "New Mexico" },
    { id: "NY", text: "New York" },
    { id: "NC", text: "North Carolina" },
    { id: "ND", text: "North Dakota" },
    { id: "OH", text: "Ohio" },
    { id: "OK", text: "Oklahoma" },
    { id: "OR", text: "Oregon" },
    { id: "PA", text: "Pennsylvania" },
    { id: "RI", text: "Rhode Island" },
    { id: "SC", text: "South Carolina" },
    { id: "SD", text: "South Dakota" },
    { id: "TN", text: "Tennessee" },
    { id: "TX", text: "Texas" },
    { id: "UT", text: "Utah" },
    { id: "VT", text: "Vermont" },
    { id: "VA", text: "Virginia" },
    { id: "WA", text: "Washington" },
    { id: "WV", text: "West Virginia" },
    { id: "WI", text: "Wisconsin" },
    { id: "WY", text: "Wyoming" },
    { id: "AS", text: "American Samoa" },
    { id: "GU", text: "Guam" },
    { id: "MP", text: "Northern Mariana Islands" },
    { id: "PR", text: "Puerto Rico" },
    { id: "UM", text: "United States Minor Outlying Islands" },
    { id: "VI", text: "Virgin Islands" }
];

export function numericDropDownValues(start, end) {
    let arrayDropDown = [{ id: "select", text: "Select" }];
    for (let i = start; i <= end; i++) {
        let row = {
            id: i.toString(), text: i.toString()
        }
        arrayDropDown.push(row);
    }
    return arrayDropDown;
}

export let yesNoValuesDropdown = [
    { id: "select", text: "Select" },
    { id: "Yes", text: "Yes" },
    { id: "No", text: "No" }
];

export let hazardValuesDropdown = [
    { id: "select", text: "Select" },
    { id: "none", text: "None" },
    { id: "earthquake", text: "Earthquake" },
    { id: "extreme_heat", text: "Extreme Heat" },
    { id: "flooding", text: "Flooding" },
    { id: "hurricanes", text: "Hurricanes" },
    { id: "tornadoes", text: "Tornadoes" },
    { id: "winter_weather", text: "Winter Weather" },
    { id: "wildfires", text: "Wildfires" }, 
    { id: "other", text: "Other" }
];

export let nationalPartnerTypeDropdown = [
    { id: "select", text: "Select" },
    { id: "none", text: "None" },
    { id: "almost_family", text: "Almost Family" },
    { id: "buddhists_tzu_chi_foundation", text: "Buddhists Tzu Chi Foundation" },
    { id: "catholic_charities_usa", text: "Catholic Charities USA" },
    { id: "church_of_the_brethren", text: "Church of the Brethren" },
    { id: "church_of_the_latter_day_saints", text: "Church of the Latter Day Saints" },
    { id: "habitat_for_humanity", text: "Habitat for Humanity" },
    { id: "hope_worldwide", text: "HOPE worldwide" },
    { id: "lott_carey", text: "Lott Carey" },
    { id: "meals_on_wheels", text: "Meals on Wheels" },
    { id: "north_american_mission_board_southern_aptists", text: "North American Mission Board/ Southern Baptists" },
    { id: "rebuilding_together", text: "Rebuilding Together" },
    { id: "saint_vincent_de_paul", text: "Saint Vincent De Paul" },
    { id: "team_rubicon", text: "Team Rubicon" }
];

export let localPartnerTypeDropdown = [
    { id: "none", text: "None" },
    { id: "emergency_management", text: "Emergency Management" },
    { id: "faith_Based_organization", text: "Faith-Based Organization" },
    { id: "fire_department", text: "Fire Department" },
    { id: "for-Profit_business_or_company", text: "For-Profit Business or Company" },
    { id: "law_enforcement", text: "Law Enforcement" },
    { id: "loca_or_state_government", text: "Local or State Government" },
    { id: "military_or_veterans_organization", text: "Military or Veterans Organization" },
    { id: "non-Profit_or_community_organization", text: "Non-Profit or Community Organization" },
    { id: "red_cross_americorps_member", text: "Red Cross AmeriCorps Member" },
    { id: "tribal_organization", text: "Tribal Organization" },
    { id: "Bbilding_property_managers", text: "Building/Property Managers" },    
    { id: "other", text: "Other" }
];


export function switchIdBTextValue(myArray, dropDownArray) {
    for (let a = 0; a < myArray.length; a++) {
        let text = getTextFromDropDown(myArray[a], dropDownArray);
        myArray[a] = text;
    }
    return myArray;
}

export function getTextFromDropDown(nameKey, myArray) {
    for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].id === nameKey) {
            return myArray[i].text;
        }
    }
}